module.exports = __webpack_public_path__ + "media/images/demo/pricing-01fb5b94a5117fa4466dc1d5574811d3.jpg";